export function requireElement<T extends HTMLElement>(selector: string, root: ParentNode = document): T {
  const element = root.querySelector<T>(selector);
  if (!element) {
    throw new Error(`Missing required element: ${selector}`);
  }
  return element;
}

export function clearElement(element: HTMLElement): void {
  while (element.firstChild) element.removeChild(element.firstChild);
}

export function createElement<K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  options: { className?: string; text?: string; html?: string; attrs?: Record<string, string> } = {}
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tagName);
  if (options.className) element.className = options.className;
  if (options.text !== undefined) element.textContent = options.text;
  if (options.html !== undefined) element.innerHTML = options.html;
  for (const [key, value] of Object.entries(options.attrs ?? {})) {
    element.setAttribute(key, value);
  }
  return element;
}

export function setStatus(container: HTMLElement, message: string, tone: "info" | "success" | "error" = "info", _timeoutMs = 0): void {
  // Status messages stay visible until the user closes them. The final
  // argument is intentionally ignored for backward-compatible call sites.
  const previousTimer = Number(container.dataset.statusTimer ?? 0);
  if (previousTimer) window.clearTimeout(previousTimer);
  delete container.dataset.statusTimer;

  container.className = `status status--${tone}`;
  container.hidden = false;
  container.innerHTML = "";

  const messageElement = document.createElement("span");
  messageElement.textContent = message;
  container.append(messageElement);

  const closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.className = "status__close";
  closeButton.setAttribute("aria-label", "Close message");
  closeButton.textContent = "×";
  closeButton.addEventListener("click", () => {
    container.hidden = true;
  });
  container.append(closeButton);
}
